import React from 'react';
import { StyledVerticalLineSvgLine, StyledVerticalLineSvg, Wrapper, Legend, TooltipText } from './styled-components';
export var Tooltip = function Tooltip(_ref) {
  var tooltip = _ref.tooltip,
      selectedIndex = _ref.selectedIndex,
      lineColor = _ref.lineColor,
      lineHeight = _ref.lineHeight,
      showLegend = _ref.showLegend;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(StyledVerticalLineSvg, {
    x: tooltip.projectedMarkerPosition.x,
    y: 0,
    lineHeight: lineHeight,
    showLine: showLegend,
    viewBox: "0 0 3 ".concat(lineHeight ? lineHeight + 2 : 340)
  }, /*#__PURE__*/React.createElement(StyledVerticalLineSvgLine, {
    lineColor: lineColor,
    x1: "3",
    y1: "1",
    x2: "1.5",
    y2: lineHeight ? lineHeight : 340
  })), /*#__PURE__*/React.createElement(Legend, {
    x: tooltip.projectedMarkerPosition.x,
    y: 75,
    selectedIndex: selectedIndex,
    animate: {
      scale: [0, 1, 1, 1, 1]
    },
    transition: {
      duration: 0.7,
      delay: 0.2,
      ease: [0.55, -0.21, 0.14, 1.24]
    }
  }, /*#__PURE__*/React.createElement(TooltipText, null, tooltip.date)));
};